import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_06e7508c-1e62-492f-99e4-396c2a55bc67/artifacts/skihh497_Copia%20de%20HISTORIAS%20ORG%20RAM%20%28Tu%20historia%29%20%281%29.png";

const teamMembers = [
  {
    name: 'Sergio Villar',
    role: 'Asesor de Seguros',
    image: 'https://customer-assets.emergentagent.com/job_06e7508c-1e62-492f-99e4-396c2a55bc67/artifacts/m0tasbv3_Imagen%201.jpg',
    description: 'Soy Sergio Villar, me encargo de ofrecerte la mejor asesoría conforme a tus necesidades y posibilidades para que tengas la mejor conciencia aseguradora, y también para acompañarte en el proceso de siniestros, brindándote la mejor atención y dándole seguimiento en todo el proceso del mismo.'
  },
  {
    name: 'Magali Martino',
    role: 'Asesora de Seguros',
    image: LOGO_URL,
    isLogo: true,
    description: 'Soy Magali Martino, comprometida y dedicada en cada consulta. Mi objetivo es brindarte una atención personalizada, escuchando tus necesidades para encontrar juntos la cobertura ideal. Estoy aquí para guiarte en cada paso y asegurarme de que te sientas respaldado en todo momento.'
  },
  {
    name: 'Micaela Vega',
    role: 'Asesora de Seguros',
    image: 'https://customer-assets.emergentagent.com/job_06e7508c-1e62-492f-99e4-396c2a55bc67/artifacts/z3tadsqv_IMG_6935%20%281%29.jpg',
    description: 'Soy Micaela Vega, confiable, amigable y resolutiva. Acompaño a cada persona con asesoramiento claro y soluciones concretas, para que puedas sentirte tranquilo, seguro y bien acompañado a la hora de asegurar con nosotros.'
  }
];

const TeamCard = ({ member }) => {
  return (
    <Card className="card-hover bg-card border-0 overflow-hidden h-full">
      <CardContent className="p-0 flex flex-col h-full">
        {/* Photo */}
        <div className="relative h-72 overflow-hidden bg-primary/10">
          {member.isLogo ? (
            <div className="w-full h-full flex items-center justify-center bg-primary">
              <img 
                src={member.image} 
                alt={member.name}
                className="h-32 w-auto brightness-0 invert"
              />
            </div>
          ) : (
            <img 
              src={member.image} 
              alt={member.name}
              className="w-full h-full object-cover object-top"
            />
          )}
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-4">
            <h3 className="text-xl font-bold text-white">{member.name}</h3>
            <p className="text-white/80 text-sm">{member.role}</p>
          </div>
        </div>
        
        {/* Description */}
        <div className="p-6 flex-grow">
          <p className="text-muted-foreground text-sm leading-relaxed">
            "{member.description}"
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export const Team = () => {
  return (
    <section id="equipo" className="py-24 bg-background">
      <div className="container mx-auto px-4 md:px-6">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 bg-primary/10 px-4 py-2 rounded-full mb-4">
            <i className="fas fa-users text-primary"></i>
            <span className="text-sm font-medium text-primary">Nuestro Equipo</span>
          </div>
          
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Conocé a quienes te van a{' '}
            <span className="text-primary">acompañar</span>
          </h2>
          
          <p className="text-muted-foreground text-lg">
            Nuestro equipo está comprometido en brindarte la mejor atención y asesoramiento personalizado.
          </p>
        </div>

        {/* Team Grid */}
        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {teamMembers.map((member, index) => (
            <TeamCard key={index} member={member} />
          ))}
        </div>
      </div>
    </section>
  );
};
